<template>
    View Dashboard
</template>

<script>

export default {
  name: 'Dashboard',
  components: {
  },
  data() {
    return {
    };
},
  methods: {
  },
}
</script>
